import { useNavigate } from "react-router-dom";
import { ITrainingBlocks } from "../../../../models/master/training";
import { baseURL } from "../../../../constants/commonConstants";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { IPopularTrining } from "../../../../models/dashboard/staffDashboard";
import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { setTrainigBlocks } from "../../../../store/slices/master/trainingBlockSlice";
import { getTrainingBlocks } from "../../../../action/masters/trainingActionCreator";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";
import TrainingDetails from "../../employeeTraining/components/employeeTrainingModal/trainingDetails";
import ReactModal from "react-modal";

const PopularTraining = (props: IPopularTrining) => {
  const { getAllTraingBlocks, trainingBlocks, snapShots } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pageBlockData = getPageBlockData(snapShots, pageBlockId.trainingBlocks);
  const [selectedId, setSelectedId] = useState(0);

  const handleViewAll = () => {
    navigate(ROUTER_URL.STAFF_TRAINING);
  };

  const [showEmployeeTraining, setShowEmployeeTraining] = useState(false);
  const [trainingDetail, setTrainingDetail] = useState<
    ITrainingBlocks | undefined
  >(undefined);

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getAllTraingBlocks(pageBlockId.trainingBlocks, limit.four);
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setTrainigBlocks([]));
    };
  }, []);

  useEffect(() => {
    setTrainingDetail(
      trainingBlocks?.find(
        (trainingBlock: any) => trainingBlock.id === selectedId
      )
    );
  }, [selectedId, trainingBlocks]);

  const handleClose = () => {
    setShowEmployeeTraining(false);
    setTrainingDetail(undefined);
    setSelectedId(0);
  };

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="title">
          <h2>Popular Training</h2>
          <a
            className={
              pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
            }
            title="View All Trainings"
            onClick={handleViewAll}
          >
            View All
          </a>
        </div>
        <ul className="transactions-wrap mt-3">
          {trainingBlocks?.map((training: ITrainingBlocks) => (
            <a target="_blank" href={training?.sso}>
              <li
                key={training.id}
                onClick={() => {
                  setSelectedId(training.id);
                  setShowEmployeeTraining(true);
                }}
              >
                <div className="img img-thumb">
                  <img src={baseURL + training.image} alt={training.name} />
                </div>
                <div>
                  <h3>{training.name}</h3>
                  <p className="para-hide-1">{training.description}</p>
                </div>
              </li>
            </a>
          ))}
        </ul>
      </div>
      <ReactModal
        isOpen={showEmployeeTraining}
        onRequestClose={handleClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
      >
        <TrainingDetails
          setShowEmployeeTraining={handleClose}
          trainingHelp={trainingDetail}
        />
      </ReactModal>
    </>
  );
};

const mapDispatchToProps = {
  getAllTraingBlocks: (pageBlockId: number, noOfItems?: number) =>
    getTrainingBlocks(pageBlockId, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    trainingBlocks: state.trainingBlock.trainingBlocks,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PopularTraining);
